<template>
    <Simulation :data="getCurrent()" :name="name"/>
</template>

<script>
import Simulation from '@/components/Simulation/Simulation.component.vue'

export default {
  components: {
    Simulation
  },
  props: ['name'],
  methods: {
    getCurrent() {
      return this.$i18n.t('Simulation')[this.name];
    }
  }
}
</script>
